import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Description } from '@mui/icons-material';
import './HLD.css';

export default function FunctionalRequirementsAndScale({ 
  functionalRequirements = [], 
  scale = [],
  problemTitle = '',
  documentVisible = false,
  setDocumentVisible = () => {}
}) {
  return (
    <Box sx={{ 
      height: 'calc(100vh - 64px)', 
      display: 'flex', 
      flexDirection: 'column',
      p: 4,
      maxWidth: '1400px',
      mx: 'auto',
      backgroundColor: '#f5f5f5'
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
          Functional Requirements & Scale
        </Typography>
        <Button
          variant="outlined"
          onClick={() => setDocumentVisible(!documentVisible)}
          startIcon={<Description />}
          size="small"
          sx={{
            borderColor: '#008080',
            color: '#008080',
            '&:hover': {
              backgroundColor: '#e3f2fd',
              borderColor: '#006666'
            }
          }}
        >
          {documentVisible ? 'Hide' : 'View Doc'}
        </Button>
      </Box>
      
      {/* Two Squares Side by Side */}
      <Box sx={{ 
        display: 'flex', 
        gap: 3,
        flex: 1,
        alignItems: 'stretch',
        '@media (max-width: 900px)': {
          flexDirection: 'column'
        }
      }}>
        {/* Functional Requirements Square */}
        <Paper 
          elevation={0}
          sx={{ 
            flex: 1,
            p: 3, 
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 'bold', 
              color: '#333',
              mb: 2.5,
              fontSize: '1.15rem',
              pb: 1.5,
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            Functional Requirements
          </Typography>
          
          <Box sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
            {functionalRequirements && functionalRequirements.length > 0 ? (
              <Box component="ul" sx={{ 
                m: 0, 
                pl: 0,
                listStyle: 'none',
                '& li': {
                  position: 'relative',
                  pl: 1.8,
                  mb: 1.8,
                  fontSize: '0.95rem',
                  lineHeight: 1.7,
                  color: '#444'
                },
                '& li::before': {
                  content: '"•"',
                  position: 'absolute',
                  left: 0,
                  color: '#008080',
                  fontWeight: 'bold',
                  fontSize: '1.1rem'
                }
              }}>
                {functionalRequirements.map((req, index) => (
                  <Box component="li" key={index}>
                    {req}
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#999', 
                  fontStyle: 'italic',
                  mt: 2
                }}
              >
                No functional requirements provided
              </Typography>
            )}
          </Box>
        </Paper>

        {/* Scale & Estimations Square */}
        <Paper 
          elevation={0}
          sx={{ 
            flex: 1,
            p: 3, 
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 'bold', 
              color: '#333',
              mb: 2.5,
              fontSize: '1.15rem',
              pb: 1.5,
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            Scale & Estimations
          </Typography>
          
          <Box sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
            {scale && scale.length > 0 ? (
              <Box component="ul" sx={{ 
                m: 0, 
                pl: 0,
                listStyle: 'none',
                '& li': {
                  position: 'relative',
                  pl: 1.8,
                  mb: 1.8,
                  fontSize: '0.95rem',
                  lineHeight: 1.7,
                  color: '#444'
                },
                '& li::before': {
                  content: '"•"',
                  position: 'absolute',
                  left: 0,
                  color: '#008080',
                  fontWeight: 'bold',
                  fontSize: '1.1rem'
                }
              }}>
                {scale.map((item, index) => (
                  <Box component="li" key={index}>
                    {item}
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#999', 
                  fontStyle: 'italic',
                  mt: 2
                }}
              >
                No scale information provided
              </Typography>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Instruction Banner */}
      <Box sx={{ 
        mt: 3, 
        p: 2, 
        bgcolor: '#e3f2fd', 
        borderRadius: '6px',
        borderLeft: '4px solid #1976d2'
      }}>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#1976d2', 
            fontStyle: 'italic',
            m: 0,
            fontSize: '0.9rem'
          }}
        >
          💡 Review the functional requirements and scale information above. Click "Next" to proceed to Non-Functional Requirements.
        </Typography>
      </Box>
    </Box>
  );
}